// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebaseConfig: {
        apiKey: "AIzaSyAO9IjPW_JQGuF_vsl9nMTbJcocl15Fg0I",
        authDomain: "surf-clube-conecta.firebaseapp.com",
        projectId: "surf-clube-conecta",
        storageBucket: "surf-clube-conecta.firebasestorage.app",
        messagingSenderId: "623965429363",
        appId: "1:623965429363:web:aca8823dca6d41eb7fd406",
        measurementId: "G-0Y23LVPHDT"
    },
    appleStoreId: '6740704427',
    googleStoreId: 'br.com.icons4u.clubeconecta',
    googleMapsApiKey: 'AIzaSyAuQXtBFboYfCZoWuAdqybfAphPbOmudZg',
    config: {
        local: {
            _site: 'https://app.dev.clubeconecta.app.br/',
            _media: 'https://media.fidelizavendas.com.br/',
            urlApiPadrao: 'http://localhost:3012/',
            // urlApiPadrao: 'https://api.clubeconecta.app.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/dev',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'info'
        },
        dev: {
            _site: 'https://app.dev.clubeconecta.app.br/',
            _media: 'https://media.fidelizavendas.com.br/',
            // urlApiPadrao: 'https://api.dev.clubeconecta.app.br/',
            urlApiPadrao: 'https://api.clubeconecta.app.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/dev',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'info'
        },
        hom: {
            _site: 'https://app.hom.clubeconecta.app.br/',
            _media: 'https://media.fidelizavendas.com.br/',
            urlApiPadrao: 'https://api.dev.clubeconecta.app.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/dev',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'off'
        },
        prod: {
            _site: 'https://app.clubeconecta.app.br/',
            _media: 'https://media.fidelizavendas.com.br/',
            urlApiPadrao: 'https://api.clubeconecta.app.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/prod',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'off'
        }
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
